import React, { useState } from 'react';
import { Segment, Label, Item, Image } from 'semantic-ui-react';

const Home = () => {
    return (<div>
<div className="home-banner"><a class="ui teal tag label"><h3>Touchless Hygiene Systems</h3></a></div>
<br />
<div className="ui three column grid fluid">
  
  <div className="column">
    <div className="ui fluid card">
      <div className="image">
        <img src={require("./toilet10.jpg")}/>
      </div>
      <div className="content">
        <a className="header"><p className="standard-text">Touchless Hygiene Systems prevent spreading of germs on hand and the body.</p></a>
      </div>
    </div>
  </div>
  <div className="column">
    <div className="ui fluid card">
      <div className="image">
        <img src={require("./toilet15.jpg")}/>
      </div>
      <div className="content">
        <a className="header"><p className="standard-text">Touchless Hygiene Systems’ plastic sanitary covers will reduce your facilities’ cleaning cost by
saving from paper and cleaning product you go through every day.</p></a>
      </div>
    </div>
  </div>
  <div className="column">
    <div className="ui fluid card">
      <div className="image">
        <img src={require("./toilet11.jpg")}/>
      </div>
      <div className="content">
        <a className="header"><p className="standard-text">Once you wave your hand in front of the sensory system the machine
starts to work and in seconds you have your unused, fresh, hygienic seat.</p></a>
      </div>
    </div>
  </div>
  <div className="column">
    <div className="ui fluid card">
      <div className="image">
        <img src={require("./toilet14.jpg")}/>
      </div>
      <div className="content">
        <a className="header"><p className="standard-text">Touchless Hygiene System seats come with a housing system in which a hygienic roll of toilet
cover is stored.</p></a>
      </div>
    </div>
  </div>

  <div className="column">
    <div className="ui fluid card">
      <div className="image">
        <img src={require("./toilet13.jpg")}/>
      </div>
      <div className="content">
        <a className="header"><p className="standard-text">The machine signals for
a change of a roll which is very ease.</p></a>
      </div>
    </div>
  </div>
  <div className="column">
    <div className="ui fluid card">
      <div className="image">
        <img src={require("./toilet12.jpg")}/>
      </div>
      <div className="content">
        <a className="header"><p className="standard-text">Our products are a perfect fit for hospitals, gas stations, restaurants, office buildings, schools,
movie theaters, airports.</p></a>
      </div>
    </div>
  </div>
  


</div>

      {/* <Item.Group>
        <Item>
          <Item.Image size='tiny' src={require("./toilet10.jpg")} />
    
          <Item.Content>
            <Item.Header as='a'>Header</Item.Header>
            <Item.Meta>Description</Item.Meta>
            <Item.Description>
              {/* <Image src={require("./toilet12.jpg")} /> */}
            {/* </Item.Description>
            <Item.Extra>Additional Details</Item.Extra>
          </Item.Content>
        </Item>

        <Item>
          <Item.Image size='tiny' src={require("./toilet11.jpg")} />
    
          <Item.Content>
            <Item.Header as='a'>Header</Item.Header>
            <Item.Meta>Description</Item.Meta>
            <Item.Description>
              {/* <Image src={require("./toilet12.jpg")} /> */}
            {/* </Item.Description>
            <Item.Extra>Additional Details</Item.Extra>
          </Item.Content>
        </Item>

        <Item>
          <Item.Image size='tiny' src={require("./toilet13.jpg")} />
    
          <Item.Content>
            <Item.Header as='a'>Header</Item.Header>
            <Item.Meta>Description</Item.Meta>
            <Item.Description> */}
              {/* <Image src={require("./toilet12.jpg")} /> */}
            {/* </Item.Description>
            <Item.Extra>Additional Details</Item.Extra>
          </Item.Content>
        </Item>
    
        <Item>
          <Item.Image size='tiny' src={require("./toilet12.jpg")} />
    
          <Item.Content>
            <Item.Header as='a'>Header</Item.Header>
            <Item.Meta>Description</Item.Meta>
            <Item.Description> */}
              {/* <Image src={require("./toilet12.jpg")} /> */}
            {/* </Item.Description>
            <Item.Extra>Additional Details</Item.Extra> */}
          {/* </Item.Content>
        </Item>
      </Item.Group>  */}
      
      </div>)
}

export default Home;